<template>
  <div></div>
</template>

<script>
export default {
    name: "item-7",
    components: {}
}
</script>